import { Link } from "react-router-dom";
import { AlertTriangle, useCapacity } from "@/components/capacity/useCapacity";
import { useI18n } from "@/i18n/I18nContext";

export const alertLabel = (t, a) => t(a.level === "red" ? "cap.alertRed" : "cap.alertOrange", { metric: t(`cap.m.${a.metric}`), x: Math.round(a.value) }).replace(/^⚠\s*/, "");

// Shown on every admin page while at least one metric is orange or red.
export const CapacityBanner = () => {
  const { t } = useI18n();
  const [data] = useCapacity();
  if (!data?.alerts?.length) return null;
  const red = data.alerts.some((a) => a.level === "red");
  return (
    <Link to="/admin/capacite" role="alert" data-testid="capacity-banner"
      className={`block border-b px-4 py-2 transition-colors duration-150 sm:px-8 ${red ? "border-red-500/50 bg-red-950/80 hover:bg-red-900/80" : "border-amber-500/50 bg-amber-950/70 hover:bg-amber-900/70"}`}>
      <ul className="mx-auto flex max-w-7xl flex-wrap gap-x-6 gap-y-1">
        {data.alerts.map((a) => (
          <li key={a.metric} className={`flex min-w-0 items-center gap-2 text-sm font-semibold ${a.level === "red" ? "text-red-100" : "text-amber-100"}`} data-testid={`capacity-banner-${a.metric}`}>
            <AlertTriangle level={a.level} /> <span className="min-w-0 break-words">{alertLabel(t, a)}</span>
          </li>
        ))}
      </ul>
    </Link>
  );
};
